export const LudicrousWide = 120;
export const ExtraWide = 80;
export const Wide = 40;
export const Narrow = 20;
